<template>
  <div class="settings-css manage">
    <div
      v-if="!checkPermission('manage_settings') || forbidden" >
      <h1 class="settings__title" >
        <div
          class="back-btn"
          @click="goBack('WAManage')">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.DOWN_ARROW"
            :color="SBColors.greyPrimary"
            :size="12"
            :rotate="90" />
          <p>Api keys</p>
        </div>
      </h1>
      <Forbidden />
    </div>
    <div
      v-else
      class="settings--limit-width">
      <h1 class="settings__title" >
        <div
          class="back-btn"
          @click="goBack('WAManage')">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.DOWN_ARROW"
            :color="SBColors.greyPrimary"
            :size="12"
            :rotate="90" />
          <p>Api keys</p>
        </div>
      </h1>

      <!-- <SettingsNote
        :icon="SBIconList.BROWSER"
        :text="`Learn more about how to use AI Number Rest API in our <a href='${webhookDocsUrl}' target='blank'>documentation</a>.`" /> -->

      <Spinner
        v-if="!appKeyLoaded"
        class="mt-5"
        :thickness="2" />

      <template v-else>
        <div style="padding-top: 15px;" />
        <b-form-group>
          <label
            for="p-key"
            class="settings__label" >
            Public key
          </label>
          <CopyInput
            :value="appKey.public_key"
            :icon-button="true" />
        </b-form-group>

        <b-form-group>
          <label
            for="p-key"
            class="settings__label" >
            Secret key
          </label>
          <CopyInput
            :value="appKey.private_key"
            :hidden="true"
            :icon-button="true"
            :show-button="true"
            :show-icon="true"
            :hide-icon="true" />
        </b-form-group>

        <div class="settings__actions flex justify-end">
          <b-button
            class="flex center-all"
            @click="generateKeys">
            <SBIcon
              class="mr-2"
              :icon="SBIconList.KEY"
              :color="SBColors.blackPrimary"
              :size="12"/>
            <span>Regenerate keys</span>
          </b-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ToasterMixin from '@/mixins/Toaster';
import SettingsNote from '../partials/SettingsNote';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import CopyInput from '@/components/common/CopyInput';
import Spinner from '@/components/common/Spinner';
import NoPermissionMixin from '@/mixins/AccessPermission';
import UserPermissionsMixin from '@/mixins/UserPermissions.mixin';
import CommonActions from '@/components/manage/CommonActions.mixin';

export default {
  name: 'APISettings',
  components: {
    SettingsNote,
    CopyInput,
    SBIcon,
    Spinner,
  },
  mixins: [
    ToasterMixin,
    NoPermissionMixin,
    UserPermissionsMixin,
    CommonActions,
  ],
  props: {
    business: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      showPassword: false,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      appKeyLoaded: 'merchant/appKeyLoaded',
      appKey: 'merchant/appKey',
      appKeyUpdated: 'merchant/appKeyUpdated',
      sendbeeDevelopersDocs: 'system/sendbeeDevelopersDocs',
      userPermissions: 'user/userPermissions',
    }),
    webhookDocsUrl() {
      return `${this.sendbeeDevelopersDocs}/#webhooks`;
    },
  },
  watch: {
    $route() {
      if (this.checkPermission('manage_settings') && this.$route.params.businessId) {
        this.permissionRoleChanges = {};
        this.fetchAppKey(this.$route.params.businessId);
      }
    },
    appKeyUpdated(newState) {
      if (newState) {
        this.fetchAppKey(this.$route.params.businessId);
        this.showToaster('Keys have been successfully regenerated.', null, null, 'OK');
      }
    },
    userPermissions() {
      if (this.checkPermission('manage_settings') && this.$route.params.businessId) {
        this.permissionRoleChanges = {};
        this.fetchAppKey(this.$route.params.businessId);
      }
    },
  },
  mounted() {
    // in case user returns to the page. On first mount business is undefined so this will not trigger
    if (this.checkPermission('manage_settings') && this.$route.params.businessId) {
      this.fetchAppKey(this.$route.params.businessId);
    }
    this.finalizeSplashView();
  },
  methods: {
    ...mapActions({
      fetchAppKey: 'merchant/fetchAppKey',
      updateAppKey: 'merchant/updateAppKey',
      finalizeSplashView: 'organisation/finalizeSplashView',
    }),
    generateKeys() {
      this.$confirmPluginModal.show({
        title: 'Regenerate Api keys',
        message: 'Are you sure you want to regenerate Api keys? Your old keys will <b>stop working instantly</b>.',
        confirmButtonText: 'Regenerate',
        confirmCallback: () => { this.updateAppKey(this.$route.params.businessId); },
      });
    },
  },
};
</script>

<style lang="scss">
.input-group .input-group-append .btn {
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
}

.input-group .input-group-append .btn:hover,
.input-group .input-group-append .btn:active {
  border: solid 1px #cfd8dc;
  background-color: #f8fafb;
}
</style>
